// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3bRTl","savePackageButton":"ClientWallet_savePackageButton__1itSM"};